module.exports = "mutation createResubmission($adviceRequestId:String!){createResubmission(adviceRequestId:$adviceRequestId)}"